var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clickable close-button-container",on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":require("@/assets/icons/ic-close-small-light.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }